import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { TabCategory } from '../../models/tab_category.model';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from "src/environments/enviroment.prod";
import { HttpClient } from '@angular/common/http';


export interface CategoryState extends EntityState<TabCategory> {
  finalProductId?: number;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'category' })
export class CategoryStore extends EntityStore<CategoryState> {
  constructor(private http: HttpClient) {
    super();
  }

  fetchAndStoreCategory(finalProductId: number, queryParams: string): Observable<{ data: TabCategory[] }> {
    this.setLoading(true);


    return this.http.get<{ data: TabCategory[] }>(environment.apiLink + `/final_product/${queryParams}/categories`)
    .pipe(
      tap(response => {
        this.setLoading(false);

        // Rebuilding through the positional constructor without the last two
        // args silently reset every category's image and is_entry_option to
        // the constructor's defaults on every refetch.
        const dataWithFinalProductId = response.data.map(category => new TabCategory(
          category.id,
          category.product_card_id,
          category.name,
          category.order,
          category.selectionRequired,
          category.showMaterials,
          finalProductId,
          category.sosource,
          category.image,
          category.is_entry_option));


          console.log('data in category query', dataWithFinalProductId);

          this.upsertMany(dataWithFinalProductId);
          this.update({finalProductId: finalProductId});


      })
    )
  }
}
